/*
 * 模块名称:迪迪结账清算模块
 * 创建人: DrugsZ 
 * 创建时间: 2018-01-05 16:25:24 
 * 修改人:   DrugsZ 
 * 最后修改时间: 2018-01-05 16:25:24 
 */

<template>
  <div class="wrapper-content animated fadeInRight tabBox" id="ac-to-didi" v-loading="loadingstatus" element-loading-text="加载中" style="position:relative">
      <div class="ibox-content">
          <div class="form-horizontal">
              <div class="form-group">
                  <label class="col-sm-1 control-label">救援公司</label>
                  <div class="col-sm-2">
                      <select class="form-control" v-model="queryParam.customerId">
                          <option v-for="item in groupList" :value="item.id">{{item.groupName}}</option>
                      </select>
                  </div>
                  <label class="col-sm-1 control-label">时间范围(起)</label>
                  <div class="col-sm-2" v-bind:class="{ 'form-group--error': !validDates }">
                      <datepicker class="form-control"  v-model="queryParam.startTime"></datepicker>
                      <p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
                  </div>
                  <label class="col-sm-1 control-label">时间范围(止)</label>
                  <div class="col-sm-2" v-bind:class="{ 'form-group--error': !validDates }">
                      <datepicker class="form-control"  v-model="queryParam.endTime"></datepicker>
                      <p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
                  </div>
                  <div class="col-sm-2 t_center">
                      <button class="btn btn-primary" @click="getClosing">费用汇总</button>
                  </div>
              </div>
              <div class="form-group">
                  <label class="col-sm-3 control-label t_left col-sm-offset-1">本时间段内累计救援次数：<span style="color:#F23F3C">{{this.totalRescueTime}}</span></label>
                  <label class="col-sm-3 control-label t_left">统计时间范围：<span style="color:#F23F3C">{{queryParam.startTime}}</span><span v-if="canShow">至</span><span style="color:#F23F3C">{{queryParam.endTime}}</span></label>
              </div>
              <div class="form-group t_right">
                  <label class="col-sm-3 control-label t_left col-sm-offset-1">本时间段内累计平台费用：<span style="color:#F23F3C">{{this.totalPlatformCost}}</span><span v-if="this.totalPlatformCost!=''">(¥)</span></label>
                  <label class="col-sm-1 control-label t_left">费用包含结算状态：</label>
                  <div class="col-sm-1 pt5px t_left" v-for="item in udcList">
                    <label>
                    	<checkbox v-model="item.isChecked" @change="getClosing">{{item.udcname}}</checkbox>
					</label>
                  </div>
              </div>
              <div class="form-group">
                  <label for="" class="col-sm-1 t_right">
                      上传结算凭证
                  </label>
                  <div class="col-sm-9">
                      <dropzone  id="myVueDropzone1"
                        :headers="header"
                        :url="type1path"
                        :language="language"
                        :acceptedFileTypes="acceptedFiles"
                        :maxFileSizeInMB="maxFileSizeInMB"
                        v-on:vdropzone-success="showSuccess"
                        :useFontAwesome = true
                        ref="upLoad"
                        v-on:vdropzone-error="showError"></dropzone>
                  </div>
              </div>
              <div class="form-group">
                  <label for="" class="col-sm-1 t_right">结算说明</label>
                  <div class="col-sm-9">
                      <textarea  class="form-control" rows="4" v-model="queryParam.memo"></textarea>
                  </div>
              </div>
              <div class="form-group">
                  <div class="col-sm-12 t_center">
                      <button class="btn btn-primary" @click="getHering">收款清账</button>                      
                  </div>
              </div>
          </div>
          <div class="hr-line-dashed"></div>
          <account-list ref="accountLsit" @onerror="this.openModalMsg"></account-list>
        <tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
      </div>
  </div>
</template>
<script>
    import Dropzone from 'vue2-dropzone'
    import Datepicker from 'components/common/datepicker/Datepicker'
    import Checkbox from 'components/common/Checkbox'
    import AccountList from 'components/pages/accountcheck/AccountList'
    import TabModal from 'components/common/TabModal'
    import classlist from 'util/classlist'
    import { OPERATE_EXCEPTION} from 'static/message'
    import toastr from 'assets/plugins/toastr/toastr.min.js' 
    import { getDictionaryFromArray } from 'util/util'	

    export default{
        name:'PageAccountCheckTodidi',
        components:{
            Datepicker,
            Dropzone,
            Checkbox,
            AccountList,
            TabModal
        },
        data(){
            return{
                saveid:'',
                type:'',
                language: {
					dictDefaultMessage:'<br><button type="button" class="btn btn-primary" style="position: absolute;left: 50px;">选择文件</button>',
					dictResponseError:'上传失败！',
					dictFileTooBig:'最大上传6MB的文件',
					dictRemoveFile:'移除',
                    dictInvalidFileType: "文件类型只能是图片类型",
                    dictMaxFilesExceeded:"最多可上传五张图片"
                },
                acceptedFiles:"image/*",
                type1path:process.env.API_INSURANCE_ROOT +"/rescue-api/photo/upload",
                header:{
                    'access-token':this.$store.state.user.accesstoken
                },
                groupList:[],
                fileInfoList:[],
                loadingstatus:false,
                queryParam:{
                    customerId:'',
                    endTime:'',
                    memo:'',
                    startTime:'',
                    type:'1',
                    certificatePhoto:''
                },
                scrollTop:'0',
                udcList:[],
                messageStr:'',
                picArr:[],
                totalRescueTime:'',                 //累计救援次数
                totalPlatformCost:'',               //累计救援费用
                maxFileSizeInMB:6,
            }
        },
        beforeMount(){
            this.getCoustomer()
            this.getUdc();
        },
        computed: {
			//	起止时间是否合法
			validDates: function(){
				if(this.queryParam.startTime && this.queryParam.endTime && this.queryParam.startTime > this.queryParam.endTime){
					return false;
				} else {
					return true;
				}
            },
            canShow(){
                return this.queryParam.startTime!=''||this.queryParam.endTime!=''
            }
		},
        methods:{
            getCoustomer(){
                // this.loadingstatus = true;
                this.$http.get(process.env.API_INSURANCE_ROOT+'/rescue-api/account/customer/fleet')
                .then(res=>{
                   if(res.body.success){
                       this.groupList = res.body.data;
                       this.queryParam.customerId = this.groupList[0].id;
                   }else{
                       this.openModalMsg(res.body.message)
                   }
                   this.loadingstatus = false;
                },res=>{
                    this.loadingstatus = true;
                    this.openModalMsg(res.body.message)
                }).catch(res=>{
                    this.loadingstatus = true;
                    this.openModalMsg(OPERATE_EXCEPTION)
                })
            },
            checkTime(){
                if(this.queryParam.startTime==''){
                    this.openModalMsg('请选择开始时间')
                    return true;
                }
                if(this.queryParam.endTime==''){
                    this.openModalMsg('请选择结束时间')
                    return true;
                }
                return false;
            },
            getHering(){
                if(this.checkTime())return;
                let para = {};
                para.closingTypes = this.getClosingStatusStr();
                para.customerId = this.queryParam.customerId;
                para.startTime = this.queryParam.startTime;
                para.endTime = this.queryParam.endTime;
                para.memo = this.queryParam.memo;
                para.certificatePhoto =  this.getPicStr(this.picArr);
                para.type = 1
                this.loadingstatus = true;
                this.$http.post(process.env.API_INSURANCE_ROOT+'/rescue-api/cost/platform/settle',para)
                .then(res=>{
                    if(res.body.success){
                        this.openModalMsg('操作成功')
                        this.$refs.accountLsit.loadData();
                        this.reset()
                    }else{
                        this.openModalMsg(res.body.message)
                    }
                    this.loadingstatus = false;
                },res=>{
                    this.loadingstatus = false;
                    this.openModalMsg(res.body.message);                    
                }).catch(res=>{
                    this.loadingstatus = false;
                    this.openModalMsg(OPERATE_EXCEPTION);                    
                })
            },
            closeModalMsg(){
                this.$refs.modalMsg.close()
                classlist.toggleScroll('open','#ac-to-didi',this);
            },
            openModalMsg(msg){
                this.$refs.modalMsg.open()
                this.messageStr = msg
                classlist.toggleScroll('close','#ac-to-didi',this);
            },
            getClosingStatusStr(){
                let tempArr = [];
                this.udcList.forEach(item => {
                     if(item.isChecked){
                        tempArr.push(item.udccode);
                    }
                });
                return tempArr.join(',');
            },
            getPicStr(item){
                if(item.length>0)return item.join(',')
            },
            setClosingStatusStr(statusStr){
                let n = statusStr;
                 this.udcList.forEach(item=>item.isChecked = false)
                if(n.indexOf(',')>-1){
                    let arr = n.splite(',');
                }else{
                    n = statusStr
                }
                if(typeof(n).toUpperCase =='ARRAY'&&n.length>0){
                    for (let key of n) {
                        this.udcList.map(item=>{
                            if(item.udccode == key){
                                item.isChecked = true;
                            }
                        })
                    }
                }else{
                    this.udcList.map(item=>{
                        if(item.udccode==n){
                            item.isChecked = true
                        }
                    })
                }
            },
            getUdc(){
                // this.loadingstatus = true;
                this.$http.get(process.env.API_ROOT+'/system/udcs/license/2',{ params: { udcTypes: 'CLOSING_STATUS' } })
                .then(res=>{
                    if(res.body.success){
                        let udcList = res.data.data['CLOSING_STATUS'];
                        if(udcList.length>0){
                            udcList.map(item=>{
                                item.isChecked = true;
                                if(item.udccode == 2||item.udccode ==4){
                                    this.udcList.push(item);
                                }
                            })
                        }
                    }else{
                        this.openModalMsg(res.body.message)
                    }
                    this.loadingstatus = false;
                },res=>{
                    this.loadingstatus = false;
                    this.openModalMsg(res.body.message)
                }).catch(res=>{
                    this.loadingstatus = false;
                    this.openModalMsg(OPERATE_EXCEPTION)
                })
            },
            // sleepTime(){
            //     this.$nextTick(function(){
            //         this.getClosing()
            //     })
            // },
            reset(){
                this.udcList.forEach(item=>{
                    item.isChecked = true;
                })
                this.queryParam.startTime = '';
                this.queryParam.endTime = '';
                this.queryParam.memo = '';
                this.totalPlatformCost = '';
                this.totalRescueTime='';
                this.$refs.upLoad.removeAllFiles()
            },
            getClosing(){
                if(this.checkTime())return;             
                let para = {};
                para.closingTypes = this.getClosingStatusStr();
                para.customerId = this.queryParam.customerId;
                para.startTime = this.queryParam.startTime;
                para.endTime = this.queryParam.endTime;
                this.loadingstatus = true;
                this.$http.get(process.env.API_INSURANCE_ROOT+'/rescue-api/cost/platform/statistics',{params:para})
                .then(res=>{
                    if(res.body.success){
                        //this.setClosingStatusStr(res.body.data.closingStatus)
                        this.totalPlatformCost = res.body.data.totalPlatformCost;
                        if(this.totalPlatformCost>0){
                            this.totalPlatformCost = this.totalPlatformCost/100
                        }
                        this.totalRescueTime = res.body.data.totalRescueTime;
                    }else{
                         this.openModalMsg(res.body.message)
                    }
                     this.loadingstatus = false;
                },res=>{
                    this.loadingstatus = false;
                     this.openModalMsg(res.body.message)
                }).catch(res=>{
                    this.loadingstatus = false
                     this.openModalMsg(OPERATE_EXCEPTION)
                })
            },
            showSuccess:function (file,response) {
                if (response.message==''){
                    this.picArr.push(response.data)
                    toastr.info('上传成功') 
                }else{
                    toastr.info(response.message) 
                }
            },
            showError:function (file,response) {
                toastr.error('最多可上传五张图片')
            }
        }
    }
</script>
<style>
 .MaxPic_Account{
            background-color:rgba(93, 93, 96, .6);
            position: absolute;
            top:0;
            left:0;
            display: flex; justify-content:center; align-items:center; 
            z-index: 9999999;
            width:100%;
            height:100%;
        }
    .Arrow_Account{
        width: 50px;
        height: 50px;
        border-radius: 50%;
        border: 1px solid #fff;
        position: absolute;
        top: 50%;
        transform: translateY(-50%)
    }
    .rightArrow_Account{1
        display: block;
        border-right: 5px solid #fff;
        border-bottom: 5px solid #fff;
        width: 20px;
        height: 20px;
        transform: translate(-50%,-50%);
        top: 50%;
        left: 50%;
        position: absolute;
    }
    .leftArrow_Account{
        display: block;
        border-right: 5px solid #fff;
        border-bottom: 5px solid #fff;
        width: 20px;
        height: 20px;
        transform: translate(-50%,-50%);
        top: 50%;
        left: 50%;
        position: absolute;
    }
    .left_Account{
        left: 30px;
        transform: rotatez(135deg);
    }
    .left_Account:hover,.right_Account:hover{
        border: 5px solid #fff;
        transition:1s;
    }
    .right_Account{
        right:30px;
        transform: rotatez(-45deg);
    }
    .imgWrapper_Account{
        width: 25%;
        height: 80%;
        left: 50%;
        top: 10px;
        padding: 3px;
        background: #fff;
        box-shadow: 10px 10px 5px #888888;
    }
    .imgWrapper_Account img{
        width: 100%;
        height:100%;
    }
</style>



// WEBPACK FOOTER //
// PageAccountCheckTodidi.vue?02ad13c6